/**
 * Harso – kokoa oma paketti (UNAVaate)
 *
 * Asiakas valitsee N kpl harsoja, jotka lisätään koriin OIKEINA
 * varianttiriveinä. Tämä komponentti ei hinnoittele mitään sitovasti:
 * PDP:llä näytetty hinta on arvio, ja lopullisen hinnan määrää Shopifyn
 * automaattinen määräalennus korissa. Siksi hintaa ei voi manipuloida
 * selaimesta.
 *
 * Portaat tulevat teema-asetuksesta muodossa "1:0;3:100;5:200"
 * (kpl:alennus senteissä per kappale), jotta hinnanmuutos ei vaadi
 * koodimuutosta.
 */
if (!customElements.get('harso-bundle')) {
  customElements.define('harso-bundle', class HarsoBundle extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 5;
      this.surcharge = parseInt(this.dataset.surcharge, 10) || 0;
      this.tiers = this.parseTiers(this.dataset.tiers);
      this.topPicks = (this.dataset.topPicks || '').split(',').map(s => s.trim()).filter(Boolean);
      this.selection = [];
      this.busy = false;

      this.els = {
        swatches: Array.from(this.querySelectorAll('.harso-bundle__swatch')),
        tierBtns: Array.from(this.querySelectorAll('.harso-bundle__tier')),
        basketItems: this.querySelector('[data-basket-items]'),
        basketCount: this.querySelector('[data-basket-count]'),
        basketMax: this.querySelector('[data-basket-max]'),
        basketMeta: this.querySelector('[data-basket-meta]'),
        addBtn: this.querySelector('[data-add]'),
        addLabel: this.querySelector('[data-add-label]'),
        autofill: this.querySelector('[data-autofill]'),
        error: this.querySelector('[data-error]')
      };

      this.preview = this.querySelector('[data-preview]');
      this.bind();
      this.render();
    }

    /** "1:0;3:100;5:200" -> [{qty:1,off:0},{qty:3,off:100},{qty:5,off:200}] */
    parseTiers(raw) {
      return (raw || '')
        .split(';')
        .map(t => t.split(':'))
        .filter(p => p.length === 2 && p[0])
        .map(p => ({ qty: parseInt(p[0], 10), off: parseInt(p[1], 10) || 0 }))
        .filter(t => t.qty > 0)
        .sort((a, b) => a.qty - b.qty);
    }

    bind() {
      this.els.swatches.forEach(btn => {
        if (btn.disabled) return;
        btn.addEventListener('click', () => this.toggle(btn));
      });

      this.els.tierBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          // Porrasnappi ei enää aseta kattoa vaan toimii pikavalintana:
          // jos valittuna on vähemmän, täytetään suosikeilla; jos
          // enemmän, ei karsita mitään (asiakas poistaa itse ruksista).
          const target = parseInt(btn.dataset.tierQty, 10) || 0;
          if (target > this.selection.length) {
            this.max = target;
            this.autofill();
          }
          this.render();
        });
      });

      if (this.els.autofill) {
        this.els.autofill.addEventListener('click', () => this.autofill());
      }

      if (this.els.addBtn) {
        this.els.addBtn.addEventListener('click', () => this.addToCart());
      }
    }

    /**
     * Näyttää valitun sävyn isona pääkuvakarusellissa.
     *
     * Sävyjen kuvat on renderöity galleriaan piilotettuina dioina
     * (product-media-slider.liquid). Tässä paljastetaan valittu ja
     * vieritetään karuselli siihen Taigan omalla scrollToSlideByID:llä
     * — samalla mekanismilla jolla pikkukuvat toimivat.
     *
     * Jos galleriaa ei löydy (esim. lohko ilman kokoelmaa), pudotaan
     * takaisin palikan sisäiseen esikatseluun.
     */
    showPreview(btn) {
      const id = btn.dataset.variantId;
      const slide = document.getElementById('item-harso-' + id);
      const slider = document.querySelector('.product-media-slider');

      if (slide && slider) {
        // Piilota aiempi sävydia, jotta karusellissa on kerrallaan yksi.
        document.querySelectorAll('.harso-bundle-slide:not([hidden])').forEach(el => {
          if (el !== slide) el.hidden = true;
        });
        slide.hidden = false;

        if (typeof slider.scrollToSlideByID === 'function') {
          slider.scrollToSlideByID(slide.id);
        } else {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        return;
      }

      if (!this.preview) return;
      const img = btn.querySelector('img');
      const pimg = this.preview.querySelector('img');
      const pname = this.preview.querySelector('[data-preview-name]');
      if (img && pimg) {
        pimg.src = img.src.replace(/([?&])width=\d+/, '$1width=600');
        pimg.alt = btn.dataset.name || '';
      }
      if (pname) pname.textContent = btn.dataset.name || '';
      this.preview.hidden = false;
    }

    toggle(btn) {
      const id = btn.dataset.variantId;
      this.showPreview(btn);
      const idx = this.selection.findIndex(s => s.id === id);

      // Ei ylärajaa: asiakas valitsee niin monta kuin haluaa ja porras
      // määräytyy sen mukaan. Kiinteä katto esti lisämyynnin — jos raja
      // tuli 3:n kohdalla, neljättä ei edes harkinnut.
      this.selection.push({
        id,
        name: btn.dataset.name,
        price: parseInt(btn.dataset.price, 10) || 0,
        pattern: btn.dataset.pattern === 'true',
        img: btn.querySelector('img') ? btn.querySelector('img').src : null
      });

      this.clearError();
      this.render();
    }

    /**
     * Täyttää loput paikat suosituimmilla sävyillä.
     *
     * Suosio tulee kahdesta lähteestä, tässä järjestyksessä:
     *
     * 1. top_picks-asetus: variantti-ID:t SÄVYKOHTAISESSA
     *    myyntijärjestyksessä. Data haettu ShopifyQL:llä
     *    (FROM sales ... GROUP BY product_variant_title), joten
     *    järjestys on todellinen eikä arvio.
     * 2. data-rank: kokoelman BEST_SELLING-järjestys tuotetasolla.
     *    Varalla jos asetus on tyhjä.
     *
     * Saman arvon sisällä järjestys satunnaistetaan, jottei paketti
     * ole joka kerta identtinen.
     */
    autofill() {
      const needed = this.max - this.selection.length;
      if (needed <= 0) return;

      const chosen = new Set(this.selection.map(s => s.id));
      const pool = this.els.swatches.filter(b =>
        !b.disabled && !chosen.has(b.dataset.variantId)
      );
      if (!pool.length) return;

      // Asetuksen top_picks menee rankin edelle, jos se on täytetty.
      const picks = this.topPicks;

      const sorted = pool
        .map(btn => {
          const pickIdx = picks.length ? picks.indexOf(btn.dataset.variantId) : -1;
          return {
            btn,
            // Asetuksessa listatut ensin, sitten myyntijärjestys.
            primary: pickIdx > -1 ? pickIdx : 1000 + (parseInt(btn.dataset.rank, 10) || 999),
            jitter: Math.random()
          };
        })
        .sort((a, b) => (a.primary - b.primary) || (a.jitter - b.jitter))
        .map(x => x.btn);

      sorted.slice(0, needed).forEach(btn => this.toggle(btn));
    }

    /**
     * Seuraava porras johon kannattaa tähdätä. Käytetään tyhjien
     * paikkojen näyttämiseen: jos valittuna on 4 ja portaat ovat 1/3/5,
     * näytetään yksi tyhjä paikka (vihje viidenteen).
     */
    nextTarget(qty) {
      const bigger = this.tiers.filter(t => t.qty > qty).sort((a, b) => a.qty - b.qty)[0];
      if (bigger) return bigger.qty;
      const top = this.tiers.length ? this.tiers[this.tiers.length - 1].qty : qty;
      return Math.max(qty, top);
    }

    /** Voimassa oleva porras valitulle määrälle. */
    currentTier(qty) {
      let match = { qty: 1, off: 0 };
      this.tiers.forEach(t => { if (qty >= t.qty) match = t; });
      return match;
    }

    estimate() {
      const tier = this.currentTier(this.selection.length);
      let total = 0;
      this.selection.forEach(s => {
        total += Math.max(0, s.price - tier.off);
      });
      return { total, tier, patterns: this.selection.filter(s => s.pattern).length };
    }

    money(cents) {
      if (window.Woolman && window.Woolman.Utils && window.Woolman.Utils.formatMoney) {
        return window.Woolman.Utils.formatMoney(cents);
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    render() {
      const n = this.selection.length;
      // Aktiivinen porras seuraa valittua määrää. Paketti on "valmis"
      // kun jokin porras täyttyy — siitä eteenpäin voi yhä lisätä.
      const tier = this.currentTier(n);
      this.max = this.nextTarget(n);

      // Porrasnapit: aktiivinen on se porras jonka asiakas on SAAVUTTANUT,
      // ei valittu raja. Klikkaus toimii pikavalintana (täyttää/karsii).
      this.els.tierBtns.forEach(btn => {
        const q = parseInt(btn.dataset.tierQty, 10);
        const active = n > 0 && q === tier.qty;
        btn.classList.toggle('is-active', active);
        btn.classList.toggle('is-reached', n >= q);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Swatchien valintamerkit
      this.els.swatches.forEach(btn => {
        // Lappu kertoo montako KAPPALETTA tätä sävyä on valittu,
        // ei valinnan järjestysnumeroa.
        const qty = this.selection.filter(s => s.id === btn.dataset.variantId).length;
        const badge = btn.querySelector('[data-swatch-badge]');
        btn.classList.toggle('is-selected', qty > 0);
        btn.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
        // Ei is-blocked-tilaa: ylärajaa ei ole, joten mitään sävyä ei
        // estetä. Aiemmin tämä harmaannutti kaikki valitsemattomat heti
        // ensimmäisen valinnan jälkeen.
        btn.classList.remove('is-blocked');
        if (badge) {
          badge.textContent = qty;
          badge.hidden = qty === 0;
        }
      });

      // Ryhmäkohtaiset laskurit
      this.querySelectorAll('.harso-bundle__group').forEach(group => {
        const ids = Array.from(group.querySelectorAll('.harso-bundle__swatch'))
          .map(b => b.dataset.variantId);
        const count = this.selection.filter(s => ids.includes(s.id)).length;
        const el = group.querySelector('[data-group-count]');
        if (el) {
          el.textContent = count;
          el.classList.toggle('is-active', count > 0);
          // Tyhjä "0" näytti turhalta nollalta otsikon vieressä.
          el.hidden = count === 0;
        }
      });

      // Pakettisi-rivi
      if (this.els.basketCount) this.els.basketCount.textContent = n;
      if (this.els.basketMax) this.els.basketMax.textContent = this.max;
      if (this.els.basketItems) {
        this.els.basketItems.innerHTML = '';
        // Ryhmitellään sama sävy yhdeksi kuvaksi + määrälappu, jottei
        // 5 kpl samaa sävyä näytä viideltä eri valinnalta.
        const grouped = [];
        this.selection.forEach(sel => {
          const g = grouped.find(x => x.id === sel.id);
          if (g) { g.qty += 1; } else { grouped.push({ ...sel, qty: 1 }); }
        });
        grouped.forEach(s => {
          // Pakettisi-kuva ei ole nappi: poisto tapahtuu VAIN ruksista,
          // jotta vahinkoklikkaus ei pudota valintaa. Kuvan klikkaus
          // vaihtaa esikatselun, kuten sävyvalitsimessakin.
          const chip = document.createElement('span');
          chip.className = 'harso-bundle__chip';

          const thumb = document.createElement('span');
          thumb.className = 'harso-bundle__chip-thumb';
          thumb.setAttribute('role', 'button');
          thumb.setAttribute('tabindex', '0');
          thumb.title = s.name;
          thumb.setAttribute('aria-label', s.name);
          if (s.img) {
            const im = document.createElement('img');
            im.src = s.img; im.alt = ''; im.width = 44; im.height = 44;
            im.loading = 'lazy';
            thumb.appendChild(im);
          } else {
            thumb.textContent = s.name.slice(0, 2);
          }
          const showIt = () => {
            const src = this.els.swatches.find(b => b.dataset.variantId === s.id);
            if (src) this.showPreview(src);
          };
          thumb.addEventListener('click', showIt);
          thumb.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showIt(); }
          });

          const rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'harso-bundle__chip-remove';
          rm.innerHTML = '&times;';
          const rmLabel = (window.harsoBundleStrings && window.harsoBundleStrings.removeHint)
            ? window.harsoBundleStrings.removeHint + ': ' + s.name
            : 'Poista: ' + s.name;
          rm.title = rmLabel;
          rm.setAttribute('aria-label', rmLabel);
          rm.addEventListener('click', e => {
            e.stopPropagation();
            // Yksi kappale kerrallaan, kuten swatchin ruksikin.
            const i = this.selection.map(x => x.id).lastIndexOf(s.id);
            if (i > -1) this.selection.splice(i, 1);
            this.clearError();
            this.render();
          });
          thumb.appendChild(rm);

          if (s.qty > 1) {
            const q = document.createElement('span');
            q.className = 'harso-bundle__chip-qty';
            q.textContent = s.qty + '\u00d7';
            thumb.appendChild(q);
          }

          chip.appendChild(thumb);

          const cname = document.createElement('span');
          cname.className = 'harso-bundle__chip-name';
          cname.textContent = s.name;
          chip.appendChild(cname);

          this.els.basketItems.appendChild(chip);
        });
        for (let i = this.selection.length; i < this.max; i++) {
          const slot = document.createElement('span');
          slot.className = 'harso-bundle__chip harso-bundle__chip--empty';
          this.els.basketItems.appendChild(slot);
        }
      }

      // Hinta-arvio ja lisämyyntivihje
      const est = this.estimate();
      if (this.els.basketMeta) {
        this.els.basketMeta.textContent = '';
        if (n > 0) {
          const parts = [];
          if (est.patterns > 0) {
            parts.push(window.harsoBundleStrings
              ? window.harsoBundleStrings.includesPatterns.replace('[count]', est.patterns)
              : est.patterns + ' kuosia');
          }
          parts.push(this.money(est.total));
          this.els.basketMeta.appendChild(document.createTextNode(parts.join(' · ')));
        }

        // "Lisää vielä 1 ja säästä 5,00 €" — kertoo konkreettisen hyödyn
        // seuraavasta portaasta, jotta neljännen harson lisääminen
        // tuntuu kannattavalta.
        const nextT = this.tiers.filter(t => t.qty > n).sort((a, b) => a.qty - b.qty)[0];
        if (nextT && n > 0) {
          const need = nextT.qty - n;
          // Säästö = koko paketin alennuksen kasvu, koska porras koskee
          // kaikkia kappaleita.
          const saving = (n + need) * (nextT.off - est.tier.off);
          if (saving > 0) {
            const hint = document.createElement('span');
            hint.className = 'harso-bundle__upsell';
            const S = window.harsoBundleStrings || {};
            hint.textContent = (S.upsellHint || 'Lisää vielä [count] ja säästä [amount]')
              .replace('[count]', need)
              .replace('[amount]', this.money(saving));
            this.els.basketMeta.appendChild(hint);
          }
        }
      }

      // Lisää koriin -nappi
      if (this.els.addBtn) {
        this.els.addBtn.disabled = n === 0 || this.busy;
        if (this.els.addLabel) {
          const base = window.harsoBundleStrings
            ? window.harsoBundleStrings.addToCart
            : 'Lisää ostoskoriin';
          if (this.busy) {
            this.els.addLabel.textContent = window.harsoBundleStrings
              ? window.harsoBundleStrings.adding : '...';
          } else if (n === 0) {
            this.els.addLabel.textContent = window.harsoBundleStrings
              ? window.harsoBundleStrings.chooseFirst : 'Valitse sävyt';
          } else {
            this.els.addLabel.textContent = base + ' · ' + this.money(est.total);
          }
        }
      }

      if (this.els.autofill) {
        // Näytetään kunnes seuraava porras on saavutettu.
        this.els.autofill.hidden = n >= this.max;
      }
    }

    showError(msg) {
      if (!this.els.error) return;
      this.els.error.textContent = msg;
      this.els.error.hidden = false;
    }

    clearError() {
      if (!this.els.error) return;
      this.els.error.hidden = true;
      this.els.error.textContent = '';
      this.els.error.classList.remove('is-notice');
    }

    async addToCart() {
      if (this.busy || !this.selection.length) return;
      this.busy = true;
      this.clearError();
      this.render();

      // Sama variantti voi olla valittu useasti -> yhdistetään määräksi,
      // koska /cart/add.js ei salli kahta riviä samalla variantilla.
      const counts = new Map();
      this.selection.forEach(s => {
        counts.set(s.id, (counts.get(s.id) || 0) + 1);
      });
      const items = Array.from(counts.entries()).map(([id, quantity]) => ({
        id: Number(id),
        quantity
      }));

      try {
        const url = (window.routes && window.routes.cart_add_url)
          ? window.routes.cart_add_url + '.js'
          : '/cart/add.js';

        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ items })
        });

        const json = await res.json();

        if (!res.ok) {
          // /cart/add.js hylkää koko pyynnön jos yksikin variantti on
          // loppunut. Kerrotaan mikä, jotta valinnan voi korjata.
          throw new Error(json.description || json.message || 'error');
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: json }));

        if (window.Woolman && window.Woolman.Cart && window.Woolman.Cart.refresh) {
          window.Woolman.Cart.refresh();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

        // Avataan ostoskori teeman omalla funktiolla EIKÄ hashilla.
        //
        // window.location.hash = 'drawer-cart' jätti hashin osoitteeseen,
        // ja teeman CSS käyttää paljasta :target-valitsinta
        // (opacity:1 !important; visibility:visible). Sivu jäi siis
        // "drawer auki" -tilaan, jolloin sävyryhmien avausvalikot eivät
        // enää reagoineet klikkaukseen.
        const drawer = document.getElementById('drawer-cart');
        if (drawer) {
          if (window.Woolman && window.Woolman.Utils && window.Woolman.Utils.showModalOrDrawer) {
            window.Woolman.Utils.showModalOrDrawer('drawer-cart');
          } else {
            drawer.classList.add('initialized', 'is-open');
            document.body.classList.add('overflow-hidden');
          }
        }

        // Jos hash on jäänyt aiemmasta, siivotaan se pois jotta :target
        // ei jää päälle.
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        this.selection = [];
      } catch (err) {
        this.showError(
          (window.harsoBundleStrings && window.harsoBundleStrings.addError)
            ? window.harsoBundleStrings.addError + ' ' + (err.message || '')
            : (err.message || 'Lisäys epäonnistui.')
        );
      } finally {
        this.busy = false;
        this.render();
      }
    }
  });
}
